<div class="flex--row flex--gutter" *ngIf="hasAvailableData">
  <ng-container *ngFor="let kpi of kpis$ | async">
    <app-summary-card-kpi-chart
      class="panel flex__child--col-2 col-2 spacing--margin-bottom avoid-page-break"
      *ngIf="showKpi$(kpi) | async"
      [title]="'farmer-insights.kpis.' + kpi | translate"
      [items]="kpiItems[kpi]"
      [summaryLabel]="'farmer-insights.aggregation.Sum' | translate"
      [summaryValue]="kpiSummaryValues[kpi]"
      [summaryUnit]="kpiSummaryUnits[kpi]"
      [prefixSummaryUnit]="kpiSummaryPrefixUnits[kpi]"
      [summaryValueDecimals]="kpiSummaryDecimals[kpi]"
      [benchmarkAgendaLabel]="benchmarkTitle$ | async"
      [benchmarkValue]="kpiSummarySubValues[kpi]"
      [benchmarkUnit]="
        kpiSummarySubValues[kpi] !== undefined && isValid(kpiSummarySubValues[kpi])
          ? kpiSummaryUnits[kpi]
          : ''
      "
      [prefixBenchmarkUnit]="kpiSummaryPrefixUnits[kpi]"
      [benchmarkValueDecimals]="kpiSummaryDecimals[kpi]"
      [showBenchmarkDeviationPercentage]="true"
      [showBenchmarkDeviationColor]="showDeviationColorForKpi(kpi)"
      [isLowerThanBenchmarkBetter]="isLowerValueBetter(kpi)"
    >
    </app-summary-card-kpi-chart
  ></ng-container>
</div>
<agr-notification-empty [isEmpty]="!hasAvailableData"> </agr-notification-empty>
